<script setup lang="ts">
const {fetch: fetchCareersMeta} = useCareersMeta()
const {
  public: {baseUrl},
} = useRuntimeConfig()

const {data: initialData} = await useAsyncData('meta-careers', () => fetchCareersMeta())
const {data: meta} = useLivePreview({initialData: initialData.value, depth: 1})

const seo = meta.value?.meta

useSeoMeta({
  title: seo?.title || 'Careers | Webamboos',
  description: seo?.description,
  ogUrl: `${baseUrl}/careers`,
  ogTitle: seo?.ogTitle || seo?.title,
  ogDescription: seo?.ogDescription || seo?.description,
  ogImage: resolveMediaUrl(seo?.image),
  ogImageAlt: resolveMediaAlt(seo?.image),
})
</script>

<template>
  <Loader :pending="!meta">
    <Container class="screen-content px-2 py-32">
      <div class="relative flex w-full flex-col items-center">
        <div class="flex flex-col items-center px-8">
          <img
            src="/jobs/career-background.png"
            class="screen-content absolute top-0 -z-20 mx-auto px-0"
            role="presentation"
            alt="Background"
          />

          <Heading as="h1" size="large" align="center" class="mb-8" gradient="gray">
            {{ $t('careers.pageTitle') }} Webamboos
          </Heading>

          <Paragraph size="large" class="mb-8 max-w-lg" align="center">
            {{ $t('careers.description') }}
          </Paragraph>

          <Action @click="$scrollTo('jobs')" intent="main" size="lg">
            {{ $t('careers.button') }}
          </Action>
        </div>

        <Motion
          :initial="{opacity: 0, y: 64}"
          :animate="{opacity: 1, y: 0}"
          :transition="{ease: [0.16, 1, 0.3, 1], duration: 1}"
        >
          <CareersCarousel class="mb-16" />
        </Motion>

        <CareersSteps class="mb-32 max-w-5xl" />
        <CareersPerks class="mb-32 w-full px-0" />

        <CareersJobs class="w-full" />

        <div class="mt-[8rem] flex w-full flex-wrap justify-center gap-60 lg:gap-32 xl:gap-60">
          <WBottomCard
            :title="$t('projects.title')"
            eyebrow="Our projects"
            section-link="/projects"
            image-link="/art-projects.svg"
          />
          <WBottomCard
            :title="$t('careers.card.services.title')"
            :eyebrow="$t('careers.card.services.eyebrow')"
            section-link="/services"
            image-link="/art-team.svg"
          />
        </div>
      </div>
    </Container>
  </Loader>
</template>
